/*
 * File: Api.js
 * Project: mp-mobile-app
 *
 * Created by Dillon Neukirch on 05/20/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: API endpoints for preferences
 */
import { Http } from "api/Http";

const Api = new Http("preferences/1");

class PrefsApi {
  constructor(api) {
    this.api = api;
  }

  fetch = async keys => {
    let res = await this.api.post("/preferences", keys);
    return res.data || [];
  };

  patch = async preference => {
    let res = await this.api.post("/preferences/save", preference);
    return res.data || [];
  };
}

const newApi = new PrefsApi(Api);
export default newApi;
